"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reactRouterDom = require("react-router-dom");

var _PublicLayout = _interopRequireDefault(require("./components/layout/PublicLayout"));

var _DefaultLayout = _interopRequireDefault(require("./components/layout/DefaultLayout"));

var _AppActions = require("./logic/store/AppActions");

var _AuthActions = require("./modules/auth/AuthActions");

var _components = require("./components");

var _services = require("./logic/services");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
} // import  AuthService  from '../admin/logic/services';


var App = /*#__PURE__*/function (_Component) {
  _inherits(App, _Component);

  function App() {
    _classCallCheck(this, App);

    return _possibleConstructorReturn(this, _getPrototypeOf(App).apply(this, arguments));
  }

  _createClass(App, [{
    key: "getInnerPaths",
    value: function getInnerPaths(props) {
      // if(props.match.params && props.match.params.locale) {
      //   locale = props.match.params.locale;
      // }
      // let url = props.match.path;
      // url = url.replace(/\/$/, '');
      var customRoutes = _services.OverrideService.getRoutes();

      return _react["default"].createElement(_reactRouterDom.Switch, null, customRoutes, _react["default"].createElement(_components.AppRoute, {
        path: "/forgot-password",
        component: _PublicLayout["default"],
        unAuthenticatedOnly: true
      }), _react["default"].createElement(_components.AppRoute, {
        path: "/login",
        component: _PublicLayout["default"],
        unAuthenticatedOnly: true
      }), _react["default"].createElement(_components.AppRoute, {
        path: "",
        component: _DefaultLayout["default"],
        authenticatedOnly: true
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      if (!this.props.ready) return null;

      var InnerRouting = function InnerRouting(props) {
        return _this.getInnerPaths(props);
      };

      return _react["default"].createElement(_components.AppRouter, null, _react["default"].createElement("div", {
        className: "App"
      }, _react["default"].createElement(_reactRouterDom.Switch, null, _react["default"].createElement(_reactRouterDom.Route, {
        path: "/",
        component: InnerRouting
      })), _react["default"].createElement("div", {
        id: "modalHolder",
        className: "modal-holder"
      })));
    }
  }]);

  return App;
}(_react.Component);

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    appMounted: function appMounted() {
      return dispatch((0, _AppActions.appMountedAction)());
    },
    refreshAuth: function refreshAuth() {
      return dispatch((0, _AuthActions.refreshAuthAction)());
    }
  };
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    ready: state.ready
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(App);

exports["default"] = _default;